import PropTypes from "prop-types";
import React, { Component } from "react";

//Simple bar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { Link, withRouter } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

//scss
import "../../assets/scss/menuSearch.scss";

//Url

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.refDiv = React.createRef();
    this.state = {
      pageData: this.props.sideBarMenuData,
      searchTerm: "",
      lastMatchingMenuItem: {},
    };
  }

  componentDidMount() {
    this.initMenu(null);
  }

  initMenu(matchingMenuItem) {
    const metisMenu = new MetisMenu("#side-menu");
    metisMenu.update();
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    if (matchingMenuItem == null) {
      for (const item of items) {
        if (this.props.location.pathname === item.pathname) {
          matchingMenuItem = item;
          break;
        }
      }
    }

    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
      this.setState({ lastMatchingMenuItem: matchingMenuItem });
    }
  }

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop;
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300;
          }
        }
      }
    }, 300);
  };

  activateParentDropdown = item => {
    item.classList.add("active");

    let parent = item.parentElement;
    while (parent && parent.id !== "side-menu") {
      const tag = parent.tagName.toLowerCase();
      if (tag === "ul" || tag === "li") {
        parent.classList.add("mm-show");
      }
      if (tag === "li") {
        parent.childNodes[0].classList.add("mm-active");
      }
      parent = parent.parentElement;
      this.scrollElement(item);
    }
    this.scrollElement(item);
  };

  onChangeMenuSearch = e => {
    this.setState({ searchTerm: e.target.value.toLowerCase() });
    if (e.target.value == "") {
      this.initMenu(this.state.lastMatchingMenuItem);
    }
  };

  render() {
    const searchTerm = this.state.searchTerm;
    const pageData = this.state.pageData;
    const translate = this.props.t;
  
    const filteredItems = pageData.filter(item => {
      const subPageContainsTerm =
        item.subPageModel &&
        item.subPageModel.some(
          subItem =>
            translate(subItem.pageName).toLowerCase().includes(searchTerm) ||
            (subItem.subPageModel &&
              subItem.subPageModel.some(innerSubItem =>
                translate(innerSubItem.pageName)
                  .toLowerCase()
                  .includes(searchTerm),
              )),
        );
  
      // Alt menü öğeleri varsa ve arama terimi bulunuyorsa, öğeyi göster
      if (subPageContainsTerm) {
        return true;
      }
  
      // Alt menü var mı diye kontrol et ve arama terimi içeren öğeyi filtrele
      if (item.subPageModel) {
        return item.subPageModel.some(
          subItem =>
            translate(subItem.pageName).toLowerCase().includes(searchTerm) ||
            (subItem.subPageModel &&
              subItem.subPageModel.some(innerSubItem =>
                translate(innerSubItem.pageName)
                  .toLowerCase()
                  .includes(searchTerm),
              )),
        );
      }
  
      // Ana öğe adı arama terimi ile uyuşuyorsa göster
      return translate(item.pageName).toLowerCase().includes(searchTerm);
    });
  
    return (
      <React.Fragment>
        <SimpleBar className="h-100" ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <div className="form__group field m-4">
                <input
                  type="text"
                  className="form__field"
                  placeholder="Search"
                  name="search"
                  id="search"
                  onChange={this.onChangeMenuSearch}
                  required
                />
                <label htmlFor="search" className="form__label" style={{ color: "white" }}>
                  {translate("search")}
                </label>
              </div>
  
              {/* Render edilen öğeleri filtrele */}
              {filteredItems.map(item => (
                <li key={item.guid}>
                  <Link to={item.pageUrl} className={item.subPageModel && item.subPageModel.length > 0 ? "has-arrow"  :""}style={{ color: "white" }}>
                    <i className={item.pageIcon} style={{ color: "white" }} />
                    <span>{translate(item.pageName)}</span>
                  </Link>
  
                  {/* Alt menü varsa, alt menüyü ekle */}
                  {item.subPageModel && item.subPageModel.length > 0 && (
                    <ul className="sub-menu" aria-expanded="false">
                      {item.subPageModel
                        .filter(subItem =>
                          translate(subItem.pageName)
                            .toLowerCase()
                            .includes(searchTerm),
                        )
                        .map(subItem => (
                          <li key={subItem.guid}>
                            <Link
                              to={subItem.pageUrl}
                              className={subItem.subPageModel ? "has-arrow" : ""}
                              style={{ color: "white" }}
                            >
                              {subItem.subPageModel && (
                                <i className={subItem.pageIcon} />
                              )}
                              {translate(subItem.pageName)}
                            </Link>
  
                            {/* Alt alt menü varsa, alt alt menüyü ekle */}
                            {subItem.subPageModel && subItem.subPageModel.length > 0 && (
                              <ul className="sub-menu" aria-expanded="false" style={{ color: "white" }}>
                                {subItem.subPageModel
                                  .filter(innerSubItem =>
                                    translate(innerSubItem.pageName)
                                      .toLowerCase()
                                      .includes(searchTerm),
                                  )
                                  .map(innerSubItem => (
                                    <li key={innerSubItem.guid} style={{ color: "white" }}>
                                      <Link to={innerSubItem.pageUrl}>
                                        {translate(innerSubItem.pageName)}
                                      </Link>
                                    </li>
                                  ))}
                              </ul>
                            )}
                          </li>
                        ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  }
  
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
  sideBarMenuData: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
